import React from 'react';

export const RequiredMessageComponent = React.memo(() => (
  <p className="fr-text--sm fc-text-align--left-md-center">
    Tous les champs avec un astérisque sont obligatoires.
  </p>
));

RequiredMessageComponent.displayName = 'RequiredMessageComponent';
